import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../store';
import { openBtiDataErrorPopup } from '../../store/bti_error_data_popup';
import { CostEstimate, ICostEstimateProps } from './CostEstimate';

type TCostEstimateStateProps = Pick<ICostEstimateProps, 'bti' | 'offer'>;
type TCostEstimateDispatchProps = Pick<ICostEstimateProps, 'openBtiDataErrorPopup'>;

export function mapStateToProps(state: IState): TCostEstimateStateProps {
  return {
    bti: state.offerData.bti,
    offer: state.offerData.offer,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<IState>): TCostEstimateDispatchProps {
  return {
    openBtiDataErrorPopup: () => {
      dispatch(openBtiDataErrorPopup());
    },
  };
}

export const CostEstimateContainer = connect(mapStateToProps, mapDispatchToProps)(CostEstimate);
